import React from "react";
import { useLocation } from "react-router-dom";
import "./header.scss";
import { trackCta } from "../../../analytics";

const AiCreatorCTA = ()=> {
  const location = useLocation();
  const isAiImagesPage = location.pathname === '/ai-images';
  const learnMoreLink = isAiImagesPage ? '/ai-creator-page' : '/ai-images';
  const linkText = isAiImagesPage ? 'Learn more' : 'Check out our AI Images';

    return (
      <div className="ai-creator-cta-container manrope f-16 pd-2-l justify-in-center" id="aiCreatorCta">
        <img src='/ai_creator/ai-star-white.svg' className="mr-1 ai-creator-banner-text" alt="" aria-hidden="true" />
        <div className="ai-creator-banner-text">
        {isAiImagesPage? 'Discover our AI workflow for teams.' : 'Generate free AI images of your product in minutes.'}
        </div>
        <div className="ai-creator-banner-text-mobile">
        Product images in minutes.
        </div>
        <a
          className="ai-creator-link"
          data-attr="navbar-banner-learn-more"
          href={learnMoreLink}
          onClick={() => {
            trackCta('nav_banner_click', {
              section: 'navbar_banner',
              button: linkText,
              destination: learnMoreLink,
            });
          }}
        >
            {linkText}
            <img src='/ai_creator/right-arrow.svg' alt="" aria-hidden="true" />
        </a>
      </div>
    );
}

export default AiCreatorCTA;
